var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showSpaceDetail)?_c('SpaceDetail'):_c('section',{staticClass:"is-small"},[_c('layout-page-menu',{scopedSlots:_vm._u([{key:"pageContent",fn:function(){return [(_vm.pageView === 'spaces')?_c('SpacesList'):_vm._e(),(_vm.pageView === 'check')?_c('CheckLocationSpaces'):_vm._e()]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }